import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Link } from 'utils-next/routes'

import { Button, Theme } from '@mui/material'

import PlusIcon from 'mdi-react/PlusIcon'

import { UserFilters } from '../../components/UserFilters'
import { USER_MANAGER_NEW_USER } from '../../UserManager.routes'
import { useUserListViewStore } from './UserListViewStore'

export type UserListViewActionsProps = {
  className?: string
}

export function UserListViewActions({ className }: UserListViewActionsProps) {
  const {
    state: { filters },
    actions: { setFilters },
  } = useUserListViewStore()
  const { classes } = useStyles()
  return (
    <div className={classNames(className, classes.container)}>
      <UserFilters filters={filters} onChange={setFilters} />
      <Link className={classes.button} to={USER_MANAGER_NEW_USER}>
        <Button variant="contained" size="small" color="secondary">
          <PlusIcon />
          Create new user
        </Button>
      </Link>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    display: 'flex',
  },
  button: {
    textDecoration: 'none',
    marginLeft: spacing(2),
  },
}))
